/**
 * @fileoverview GET handler for the "/engagement/campaigns/carousel_slides_for_campaign" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCarouselSlidesForCampaign } from "./constants";
import type { EngagementCampaignsCarouselSlidesForCampaignResult } from "./types";

export const getEngagementCampaignsCarouselSlidesForCampaign = reactQueryFetcherAdapter(
  engagementCampaignsCarouselSlidesForCampaign,
  (
    signal: AbortSignal,
    appGroupId: string,
    campignId: string,
    query: string
  ): Promise<EngagementCampaignsCarouselSlidesForCampaignResult> => {
    return fetch(
      "/engagement/campaigns/carousel_slides_for_campaign",
      "GET",
      { app_group_id: appGroupId, selected_campaign_id: campignId, query },
      { signal }
    );
  }
);
